module.exports = __webpack_public_path__ + "static/media/bg-docsign.60a17834.png";